export const SHARED_EVENTS = {
  CREATE_MENU_OPENED: "Create Menu Opened",
  CREATE_OPTION_SELECTED: "Create Option Selected",
  NAVIGATION_ITEM_CLICKED: "Navigation Item Clicked"
};

export const SHARED_EVENTS_PARAMS = {
  FROM_PAGE: "from_page",
  TO_PAGE: "to_page",
  CURRENT_PAGE: "current_page",
  PAGE: "page",
  MODE: "mode",
  ACCOUNT_MID: "account_mid",
  BUSINESS_NAME: "business_name",
  FILTER_TYPE: "filter_type",
  FILTER_VALUE: "filter_value",
  START_DATE: "start_date",
  END_DATE: "end_date",
  COMPARED_START_DATE: "compared_start_date",
  COMPARED_END_DATE: "compared_end_date",
  CURRENCY: "currency",
  STATUS: "status",
  ENABLED: "enabled",
  ERR_DESCRIPTION: "error_description",
  DATE_RANGE: "date_range",
  SUCCESS: "success",
  FAILED: "failed",
  SUBSCRIPTION: 'subscription',
  ENVIRONMENT: 'environment',
  RESULT: 'result',
  CREATE_OPTION: 'create_option',
  ENTRY_POINT: 'entry_point',
  FAILURE_REASON: "failure_reason",
  NAV_ITEM: "nav_item",
  NAV_SECTION: "nav_section",
  IS_COLLAPSED_NAV: "is_collapsed_nav",
  AMOUNT: "amount"
} as const;

export const SHARED_EVENTS_VALUES = {
  SUCCESS: "success",
  FAILURE: "failure",
  PENDING: "pending",
  PAYMENT_LINK: "payment_link",
  BULK_PAYMENT_LINK: "bulk_payment_link",
  QR_CODE_PAYMENT: "qr_code_payment",
  TOP_BAR: "topbar",
};
